import React from 'react';
import appStoreIcon from '../images/app/appstore-icon.png';
import googlePlayIcon from '../images/app/googleplay-icon.png';
import appDownloadBanner from '../images/app/appdownloadbanner.png';

const AppCta = () => {
    return (
        <section className="px-4 lg:px-0 rebrand-cta-wrapper home-page-app-cta">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
                    <div className="col-span-full lg:col-span-10 lg:col-start-2 lg:col-end-12">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-holborn-app-blue rounded-2xl">
                            <div className="flex flex-col justify-center px-6 pt-6 lg:p-8">
                                <div className="text-wrapper text-left md:text-left">
                                    <h2 className="mb-0  text-4xl lg:text-6xl font-light">Download the <span className="font-bold">Holborn Assets App</span></h2>
                                    <p className="lg:py-4 text-holborn-mid-blue">Experience a seamless, secure, all-in-one financial management solution that fits in your pocket</p>
                                </div>
                                <div className="image-wrapper flex justify-start">
                                <a href="https://apps.apple.com/gb/app/holborn-assets/id6677055608" target="_blank" rel="noopener noreferrer">
                                        <img
                                            src={appStoreIcon}
                                            alt="App Store Icon"
                                            className="mr-4 w-28 md:w-36"
                                        />
                                    </a>
                                    <a href="https://play.google.com/store/apps/details?id=com.holbornassets.app" target="_blank" rel="noopener noreferrer">
                                        <img
                                            src={googlePlayIcon}
                                            alt="Google Play icon"
                                            className="w-28 md:w-36"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="flex justify-center items-end">
                                <img
                                    src={appDownloadBanner}
                                    alt="App CTA Image"
                                    className="lg:w-4/5"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AppCta;